module.exports = __webpack_public_path__ + "img/image-01.aa2c015d.webp";